import {Component, Inject, Input} from 'ng-metadata/core';
import {PhysicalBestOfferService} from '../../physicalBestOffer/physicalBestOffer.service';

@Component({
    "selector": "prm-brief-result-physical-best-offer",
    templateUrl: 'components/search/fullView/ngrs/ngrsBriefResultLine/briefResultPhysicalBestOffer/briefResultPhysicalBestOffer.html'
})

export class PrmBriefResultPhysicalBestOffer{

	@Input() private offerFound: boolean;
	@Input() private loanPeriod: number;
    @Input() private supplyTime: number;    
    @Input() private openphysicalform: Object;
    @Input() private opendigitalform: Object;

    constructor (){

    }

    ngOnInit(){
    }

	public getSupplyTime(){
        return this.supplyTime;
    }
    
    public getLoanPeriod(){
        return this.loanPeriod;
    }

    public isOfferFound(){
        return this.offerFound
    }

    public isShowBestOffer(): boolean {
        return !(this._getItFormOpen.getItFormOpen);
    }

    public showFormOnClick(event){
        this.opendigitalform.openDigitalForm = false;
        this.openphysicalform.openPhysicalForm = true;
        event.preventDefault();
        event.stopPropagation(); 
    }

}








// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/ngrs/ngrsBriefResultLine/briefResultPhysicalBestOffer/briefResultPhysicalBestOffer.directive.ts